import React, {ReactNode} from 'react'
import {AdminPageHeadingArea} from '../../../../components/shared/pageBaseComponents/AdminPageHeadingArea'
import styled from 'styled-components'
import {Box, DialogActions, DialogTitle} from '@mui/material';
import {Colors, FontWeights, LineHeight} from '../../../../styledComponents/Constants'
import {AdminDefaultButton} from '../../../../styledComponents/adminPage/Buttons'

interface ExternalProps {
    onClose: () => void
}

export interface InjectedProps {
    isResident?: boolean;
}

export const NatCreatePreviewForResident = ({}) =>
    <OriginalProps extends {}>(
        WrappedComponent: React.ComponentType<OriginalProps & InjectedProps>
    ) => {
        type ResultProps = OriginalProps & ExternalProps;

        interface State {
            isResident: boolean;
        }

        return class extends React.Component<ResultProps, State> {

            static displayName: string = `static displayName(${WrappedComponent.displayName})`;

            constructor(props: ResultProps) {
                super(props);
                this.state = {
                    isResident: false,
                };
            }

            render(): ReactNode {
                return (
                    <DialogContainer>
                        <StyledDialogTitle>
                            <AdminPageHeadingArea
                                title={'プレビュー'}
                                onClose={this.props.onClose}
                            />
                        </StyledDialogTitle>
                        <Box padding={'0px 24px'}>
                            <StyledResidentContainer>
                                <WrappedComponent
                                    {...this.props}
                                    {...this.state}
                                />
                            </StyledResidentContainer>
                        </Box>
                        <StyledDialogActions>
                            <AdminDefaultButton onClick={() => this.props.onClose()}>
                                閉じる
                            </AdminDefaultButton>
                        </StyledDialogActions>
                    </DialogContainer>
                )
            }
        }
    };

const DialogContainer = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${Colors.Background};
    height: 685px;
`;

const StyledDialogTitle = styled(DialogTitle)`
  padding-bottom: 0!important;
    padding-left: 24px !important;
    padding-right: 24px !important;
`;

const StyledResidentContainer = styled.div`
  background: ${Colors.Background};
    width: 375px;
  height: 100%;
    max-height: 530px;
    overflow-y: auto;
  box-sizing: border-box;
  font-family: "Noto Sans JP", sans-serif;
  font-size: 1rem;
  font-weight: ${FontWeights.Normal};
  line-height: ${LineHeight.Basic};
  word-break: break-all;
`;

const StyledDialogActions = styled(DialogActions)`
  justify-content: center!important;
    padding: 12px 12px 24px 12px !important;
    align-items: flex-end;
    flex-grow: 1;
`
